import { usePermissions } from '@/composables/usePermissions'

export const canDirective = {
  mounted(el, binding) {
    const { can } = usePermissions()
    
    if (!can(binding.value)) {
      el.style.display = 'none'
    }
  },
  
  updated(el, binding) {
    const { can } = usePermissions()
    el.style.display = can(binding.value) ? '' : 'none'
  }
}
